export default {
	AccessLogData: function(state) {
		return state.AccessLogData;
	},

	Total: function(state) {
		return state.Total;
	},

	CachedQuickSearchText: function(state) {
		return state.CachedQuickSearchText;
	},

	CachedFilterOptions: function(state) {
		return state.CachedFilterOptions;
	}
};
